import React from "react";
import "./about.css";
import img from "../Assets/dot.png";
import aboutimg from "../Assets/doctor-see.png";
import wapp from "../Assets/whatsapp.png";
import home from "../Assets/home.png";

const data = [
  "Holistic Wellness",
  "Collaborative Care",
  "Global Standards",
  "Trusted Expertise",
  "Integrated Services",
  "4/7 Emergency Care",
];

function About() {
  return (
    <div className="about-section">
      <div className="about-left">
        <img src={aboutimg} alt="about" className="about-img" />
      </div>
      <div className="about-right">
        <h2 className="about-title">About Us</h2>
        <p>
          At Shri Adithya Hospital, we are committed to transforming healthcare
          by putting our patients first. Our expert medical team combines
          cutting-edge technology with compassionate care to create personalized
          treatment plans. We believe in healing beyond medicine, and your
          wellbeing inspires us in everything we do.
        </p>
        <div className="about-list">
          {data.map((ele, ind) => (
            <div className="list-item" key={ind}>
              <img src={img} className="list-icon" alt="dot" />
              <span>{ele}</span>
            </div>
          ))}
        </div>
        <div className="navigation-icon">
          <div>
            <img src={wapp} alt="wapp" />
          </div>
          <div>
            <img src={home} alt="home" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
